import Link from 'next/link';

export function TermsMarketingConsentLabel() {
  return (
    <span className="text-xs">
      I agree to the{' '}
      <Link href="/terms" target="_blank" rel="noopener noreferrer" className="font-medium text-primary underline underline-offset-2">
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link href="/privacy" target="_blank" rel="noopener noreferrer" className="font-medium text-primary underline underline-offset-2">
        Privacy Policy
      </Link>
      {' '}and receiving marketing offers.
    </span>
  );
}
